module.exports = __webpack_public_path__ + "img/shiftWorks.dbd8a80a.svg";